module.exports = __webpack_public_path__ + "img/alipay.30f00746.jpg";